export function getCategoryDomId(rawId: string): string {
  return `categoryHeading${rawId}`;
}
